import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Table, Input, Alert } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormSubmitButton from '../FormSubmitButton'

export default function AIGReportForm() {
  const location = useLocation()
  console.log('AIGReportForm rendered: ', location)
  const reportType = location.pathname.split('/')[2]

  let init = {
    datePaymentDueFrom: '',
    datePaymentDueTo: '',
    dateClosedFrom: '',
    dateClosedTo: '',
    invoicePaidFrom: '',
    invoicePaidTo: '',
    invoiceDateFrom: '',
    invoiceDateTo: '',
    showCheck: '',
    showPlaintiffCounsel: '',
    checkNumber: '',
    settlementAmount: '',
    amountOperator: '',
    plaintiffStatus: [],
    reportType: 'I'
  }

  const navigate = useNavigate()
  init = initialFormValues(`${reportType}`, navigate, init)
  const [toggle, setToggle] = useState(init.reportType)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState()

  async function submitSearch() {
    console.log('AIGReportForm.submitSearch', inputs)
    if (reportType === 'aig.aig_report') {
      inputs.reportType = 'I'
      if (toggle === 'D') {
        inputs.reportType = 'D'
      }
      if (toggle === 'IP') {
        inputs.reportType = 'IP'
      }

      let validInput = true
      if (inputs.reportType === 'I' || inputs.reportType === 'IP') {
        if (!inputs.datePaymentDueFrom || !inputs.datePaymentDueTo) {
          validInput = false
        }
        if (inputs.reportType === 'I') {
          inputs.showCheck = (inputs.showCheck === 'on' || inputs.showCheck === 'Y') ? 'Y' : ''
          inputs.showPlaintiffCounsel = (inputs.showPlaintiffCounsel === 'on' || inputs.showPlaintiffCounsel === 'Y') ? 'Y' : ''
        } else {
          delete inputs.showCheck
          delete inputs.showPlaintiffCounsel

        }
        delete inputs.invoicePaidFrom
        delete inputs.invoicePaidTo
        delete inputs.settlementAmount
      } else {
        delete inputs.datePaymentDueFrom
        delete inputs.datePaymentDueTo
        delete inputs.showCheck
        delete inputs.showPlaintiffCounsel
        delete inputs.checkNumber
      }
      delete inputs.dateClosedFrom
      delete inputs.dateClosedTo
      delete inputs.amountOperator
      delete inputs.plaintiffStatus
      if (!validInput) {
        return setFormFeedback(<tr><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ backgroundColor: '#f8d7da !important', display: 'block', textAlign: 'center', margin: 'auto' }}>Must select a "From" and "To" date</Alert></td></tr>)
      }
    } else {
      delete inputs.reportType
      let validInput = true
      if (!inputs.datePaymentDueFrom && !inputs.datePaymentDueTo && !inputs.dateClosedFrom && !inputs.dateClosedTo) {
        validInput = false
      }
      inputs.showCheck = (inputs.showCheck === 'on' || inputs.showCheck === 'Y') ? 'Y' : ''
      inputs.showPlaintiffCounsel = (inputs.showPlaintiffCounsel === 'on' || inputs.showPlaintiffCounsel === 'Y') ? 'Y' : ''
      for (let i = 0; i < inputs.plaintiffStatus.length; i++) {
        if (inputs.plaintiffStatus[i] === 'All') {
          inputs.plaintiffStatus.splice(i, 1)
        }
      }
      if (!validInput) {
        return setFormFeedback(<tr><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ backgroundColor: '#842029', display: 'block', textAlign: 'center', margin: 'auto' }}>At least one valid date range must be specified</Alert></td></tr>)
      }
    }
    submitFormValues(`${reportType}`, navigate, inputs, `${reportType}`)
  }

  let displayInput = 
    <tr>
      <td style={{ verticalAlign: 'middle' }}><b>Display</b></td>
      <td>
        Check Number  <Input className="custom-checkbox" type="checkbox" name="showCheck" onChange={handleInputChange} defaultChecked={inputs.showCheck} /> &emsp;
        Plaintiff Counsel  <Input className="custom-checkbox" type="checkbox" name="showPlaintiffCounsel" onChange={handleInputChange} defaultChecked={inputs.showPlaintiffCounsel} /> <span><br /></span>
      </td>
    </tr>

  let checkNumberInput = 
    <tr>
      <td style={{ verticalAlign: 'middle' }}><b>Check Number</b></td>
      <td>
        <Input
          type="select"
          name="checkNumber"
          onChange={handleInputChange}
          style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
          defaultValue={inputs.checkNumber}
        >
          <option value={''}></option>
          <option value={'IS NULL'}>Is Null</option>
          <option value={'IS NOT NULL'}>Is Not Null</option>
        </Input>
      </td>
    </tr>

  if (toggle === 'IP') {
    displayInput = ''
    checkNumberInput = ''
  }

  let tableBody =
    <tbody>
      <DateRangeInput label="Date Payment Due" name='datePaymentDue' handleInputChange={handleInputChange} defaultValueFrom={inputs.datePaymentDueFrom} defaultValueTo={inputs.datePaymentDueTo} />
      {displayInput}
      {checkNumberInput}
    </tbody>

  if (toggle === 'D') {
    tableBody =
      <tbody>
        <DateRangeInput label="Invoice Paid Date" name='invoicePaid' handleInputChange={handleInputChange} defaultValueFrom={inputs.invoicePaidFrom} defaultValueTo={inputs.invoicePaidTo} />
        <DateRangeInput label="Invoice Date" name='invoiceDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.invoiceDateFrom} defaultValueTo={inputs.invoiceDateTo} />
      </tbody>
  }

  if (reportType === 'aig2.aig_report') {
    tableBody = <tbody>
      <DateRangeInput label="Date Payment Due" name='datePaymentDue' handleInputChange={handleInputChange} defaultValueFrom={inputs.datePaymentDueFrom} defaultValueTo={inputs.datePaymentDueTo} />
      <DateRangeInput label="Date Closed" name='dateClosed' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateClosedFrom} defaultValueTo={inputs.dateClosedTo} />
      <tr>
        <td><b>Settlement Amount</b></td>
        <td>
          <Input style={{ width: 'auto', display: 'inline-block' }} type="select" name="amountOperator" className="operator-input" onChange={handleInputChange} defaultValue={inputs.amountOperator}>
            <option key={2} value={' = '}>Equals</option>
            <option key={0} value={' > '}>Greater Than</option>
            <option key={1} value={' < '}>Less Than</option>
          </Input>
          <Input className="custom-input" type='text' name='settlementAmount' onChange={handleInputChange} defaultValue={inputs.settlementAmount} />
        </td>
      </tr>
      <CustomSelectListInput label="Plaintiff Status" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='plaintiffStatus' multiple={true} defaultValue={inputs.plaintiffStatus} />
      <tr>
        <td style={{ verticalAlign: 'middle' }}><b>Display</b></td>
        <td>
          Check Number  <Input className="custom-checkbox" type="checkbox" name="showCheck" onChange={handleInputChange} defaultChecked={inputs.showCheck} /> &emsp;
          Plaintiff Counsel  <Input className="custom-checkbox" type="checkbox" name="showPlaintiffCounsel" onChange={handleInputChange} defaultChecked={inputs.showPlaintiffCounsel} /> <span><br /></span>
        </td>
      </tr>
      <tr>
        <td style={{ verticalAlign: 'middle' }}><b>Check Number</b></td>
        <td>
          <Input
            type="select"
            name="checkNumber"
            onChange={handleInputChange}
            style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
            defaultValue={inputs.checkNumber}
          >
            <option value={''}></option>
            <option value={'IS NULL'}>Is Null</option>
            <option value={'IS NOT NULL'}>Is Not Null</option>
          </Input>
        </td>
      </tr>
    </tbody>
  }

  let dropdown = reportType === 'aig.aig_report' ? <Input
    type="select"
    name="toggle"
    onChange={(e) => setToggle(e.target.value)}
    style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
    defaultValue={inputs.reportType}
  >
    <option value={'I'}>Indemnity Payments</option>
    <option value={'D'}>Defense Costs</option>
    <option value={'IP'}>Indemnity Payments (by Claimant's Counsel)</option>
  </Input> : ''

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <thead>
              <tr><th colSpan="2" className="custom-table-header">
                AIG Report
                <span><br /></span>
                {dropdown}
              </th>
              </tr>
            </thead>
            {formFeedback}
            {tableBody}
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

